// This module provides API call methods for Sephora Commerce Utility APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Utility+APIs

import storeLocator from 'services/api/utility/storeLocator';
import getAboutMeReviewQuestions from 'services/api/utility/getAboutMeReviewQuestions';
import getAdvocacyLandingPageContentSDN from 'services/api/utility/getAdvocacyLandingPageContentSDN';
import addToPromotion from 'services/api/utility/addToPromotion';
import getCountryList from 'services/api/utility/getCountryList';
import getShippingCountryList from 'services/api/utility/getShippingCountryList';
import getSubscriptionCancelReasons from 'services/api/utility/getSubscriptionCancelReasons';
import getGiftCardBalance from 'services/api/utility/getGiftCardBalance';
import getStateAndCityForZipCode from 'services/api/utility/getStateAndCityForZipCode';
import getStateList from 'services/api/utility/getStateList';
import getLocation from 'services/api/utility/getLocation';
import validateAddress from 'services/api/utility/validateAddress';
import isUserEligible from 'services/api/utility/isUserEligible';
import getHighlightedReviews from 'services/api/utility/getHighlightedReviews';
import taxServiceValidateAddress from 'services/api/utility/taxServiceValidateAddress';

import requestEmailNotification from 'services/api/utility/requestEmailNotification';
const { requestEmailNotificationForSubscriptionType, cancelEmailNotificationRequest } = requestEmailNotification;

export default {
    storeLocator,
    getAboutMeReviewQuestions,
    getAdvocacyLandingPageContentSDN,
    addToPromotion,
    getCountryList,
    getShippingCountryList,
    getSubscriptionCancelReasons,
    getGiftCardBalance,
    getStateAndCityForZipCode,
    getStateList,
    getHighlightedReviews,
    requestEmailNotificationForSubscriptionType,
    cancelEmailNotificationRequest,
    getLocation,
    validateAddress,
    taxServiceValidateAddress,
    isUserEligible
};
